<template>
  <div>
    <v-list :shaped="true">
      <v-list-item-group color="primary">
        <v-list-item v-for="(item, i) in navigationItems" :key="i" :to="item.path" :disabled="onlyControl">
          <v-list-item-icon>
            <v-icon v-text="item.meta.menuLink.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title data-testid="menu-title">{{ $t(item.meta.menuLink.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-divider class="my-2" />

    <v-list :shaped="true" v-if="!this.isUserSupplier()">
      <v-list-item-group>
        <v-list-item :exact="true" href="http://recap.fabrik.wiki" target="_blank" class="text-left no-focus">
          <v-list-item-icon>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title data-testid="menu-help-link">{{ $t('navigation.links.help') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { routes } from '@/router';
import { RouteConfig } from 'vue-router';
import { environment } from '../../../environment';
import { isUserSupplier } from '@/modules/authentication';

export default Vue.extend({
  name: 'TheSidebarNavigation',
  computed: {
    navigationItems(): RouteConfig[] {
      return this.flattenRoutes(routes).filter(
        route => (isUserSupplier() && route.name === 'control') || !isUserSupplier()
      );
    },
    onlyControl(): boolean {
      return environment.ONLY_CONTROL === 'true';
    }
  },

  methods: {
    flattenRoutes(routes: RouteConfig[]): RouteConfig[] {
      return routes.reduce((flattenedRoutes, route) => {
        if (route.meta && route.meta.menuLink) {
          flattenedRoutes.push(route);
        }
        if (route.children) {
          flattenedRoutes.push(...this.flattenRoutes(route.children));
        }
        return flattenedRoutes;
      }, [] as RouteConfig[]);
    },
    isUserSupplier
  }
});
</script>
